import { CognitoGroups, UserTypes } from "../store/types";

export const getUserType = (authData) => {
  const [userType] = authData['cognito:groups']
  const cognitoGroup = Object.keys(CognitoGroups).find(group =>
    userType === CognitoGroups[group])
  return cognitoGroup ? UserTypes[cognitoGroup] : UserTypes.UNAUTH;
}